/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { Reducer, AnyAction } from "redux";

import {
  GET_CURRENT_INFOBOX,
  GET_LICENSED_CONTENT,
  CONTENT_LICENSE_FAILED,
} from "../actions/types";

export type PDFContentState = {
  contentLink: string | null;
  licensedDoc: string | null;
};

export type InfoBoxState = {
  readonly currentInfoBox: any;
  readonly pdfContent: PDFContentState;
};

export enum infoboxType {
  HANDOUT = 1,
  CARD,
  TEST,
  ASSIGNMENT,
  LINK,
}

export enum testType {
  SEL_SINGLE = 1,
  SEL_MULTIPLE,
  FILL_TEXT,
  REORDER,
  MATCH,
  CATEGORIZE,
  HOT_SPOT,
}

const infoboxReducerDefaultState: InfoBoxState = {
  currentInfoBox: undefined, // infobox currently worked on, with exercises populated
  pdfContent: { contentLink: null, licensedDoc: null },
};

export const infoboxReducer: Reducer<InfoBoxState, AnyAction> = (
  state = infoboxReducerDefaultState,
  action: AnyAction,
) => {
  switch (action.type) {
    case GET_CURRENT_INFOBOX:
      return { ...state, currentInfoBox: action.payload };

    case GET_LICENSED_CONTENT:
      return { ...state, pdfContent: action.payload };

    case CONTENT_LICENSE_FAILED:
    default:
      return state;
  }
};
